// src/components/Skills.js

import React from "react";

function Skills() {
  const skills = [
    "NodeJS",
    "Golang",
    "Python",
    "PostgreSQL",
    "Rust (Solana)",
    "Solidity (Ethereum)",
    "ReactJS",
    "Docker",
    "MySQL",
    "PHP",
    "RabbitMQ",
    "React Native",
    "Angular",
    "MicroServices",
    "Web3",
    "Ubuntu",
    "Java",
    "C#",
  ];

  return (
    <section id="skills">
        <h2>Tech Skills</h2>
        <ul className="skill-list">
            {skills.map((skill, index) => (
            <li key={index}>{skill}</li>
            ))}
        </ul>
    </section>
  );
}

export default Skills;
